module.exports = __webpack_public_path__ + "img/normal_multiplier_2.7c082f88.png";